import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { useHistory, useRouteMatch } from 'react-router-dom'
import withStyles from '@material-ui/core/styles/withStyles'
import { getCountries } from 'Reducers/Countries/actions'
import {
  getDocumentTypeById,
  createDocumentType,
  updateDocumentTypeById,
  deleteDocumentTypeById,
} from 'Reducers/Document/actions'

import { DocumentCreateEditWrapper } from 'Components/Settings/Documentation/DocumentCreateEditWrapper'
import { LayoutDashboard } from 'Components/Layout/Dashboard'
import { HideWhenBlocked } from 'Containers/UIBlock/HideWhenBlocked'
import DocumentBreadcrumbs from '../DocumentBreadcrumbs/index'
import Typography from '@material-ui/core/Typography'
import LoadingIndicator from 'Components/LoadingIndicator/LoadingIndicator'
import DocumentForm from '../DocumentForm/index'

import { DOCUMENT_FORM } from '../constants'
import { PATHS } from 'Config/Routing/paths'

import { styles } from '../styles'

const Document = ({
  classes,
  mode,
  countries,
  documentType,
  getCountries,
  getDocumentTypeById,
  createDocumentType,
  updateDocumentTypeById,
  deleteDocumentTypeById,
}) => {
  const match = useRouteMatch()
  const history = useHistory()

  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    getCountries()
    if (mode === DOCUMENT_FORM.EDIT) {
      const documentId = match.params.id
      getDocumentTypeById(documentId)
    }
    return () => {
      deleteDocumentTypeById()
    }
  }, [])

  useEffect(() => {
    if (mode === DOCUMENT_FORM.CREATE || Object.keys(documentType).length) {
      setIsLoading(false)
    }
  }, [documentType])

  const getCountryCodeSelectOptions = () => {
    const countryCodeOptions = countries.map(country => ({
      label: country.code,
      value: country.code,
    }))

    countryCodeOptions.unshift({
      label: 'Please select',
      value: undefined,
    })

    return countryCodeOptions
  }

  const redirectToDocumentationList = () => {
    history.push(
      `${PATHS.main.dashboard}${PATHS.dashboard.settings}${
        PATHS.settings.documentation
      }`,
    )
  }

  const submitHandler = (values, isValid) => {
    if (!isValid) return
    const { name, countrycode, instructiontext, active } = values
    const callbacks = {
      onSuccess: redirectToDocumentationList,
    }
    const submitValues = {
      name: name.value,
      label: name.value,
      instruction_title: name.value,
      instruction_text: instructiontext.value,
      country_code: countrycode.value,
      active: mode === DOCUMENT_FORM.CREATE ? true : active.value,
    }

    if (mode === DOCUMENT_FORM.CREATE) {
      createDocumentType(callbacks, submitValues)
    } else {
      const documentId = match.params.id

      updateDocumentTypeById(callbacks, documentId, submitValues)
    }
  }

  return (
    <LayoutDashboard>
      <DocumentCreateEditWrapper>
        <DocumentBreadcrumbs currentPath={match.url} mode={mode} />
        <HideWhenBlocked>
          <Typography className={classes.title} variant="h4">
            {mode === DOCUMENT_FORM.CREATE
              ? 'Create Document'
              : !isLoading
              ? `Edit ${documentType.name}`
              : ''}
          </Typography>
          {isLoading ? (
            <LoadingIndicator />
          ) : (
            <DocumentForm
              submitHandler={submitHandler}
              mode={mode}
              documentType={documentType}
              сountryCodeSelectOptions={getCountryCodeSelectOptions()}
              redirectToDocumentationList={redirectToDocumentationList}
            />
          )}
        </HideWhenBlocked>
      </DocumentCreateEditWrapper>
    </LayoutDashboard>
  )
}

const mapStateToProps = state => ({
  countries: state.countries.countriesList,
  documentType: state.document.documentTypeById,
})

export default connect(
  mapStateToProps,
  {
    getCountries,
    getDocumentTypeById,
    deleteDocumentTypeById,
    updateDocumentTypeById,
    createDocumentType,
  },
)(withStyles(styles)(Document))



// WEBPACK FOOTER //
// ./src/Containers/Settings/Documentation/Document/index.js